module.exports = __webpack_public_path__ + "static/img/cloud.d13e4db.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/cloud.png
// module id = X842
// module chunks = 17